import api from "./api";

export const getBranches = async () => {
    try {
        const res = await api.get("/api/branches", { params: { size: 50 } });
        const responseData = res?.data;
        return Array.isArray(responseData) ? responseData : (responseData?.content || responseData?.items || responseData?.data || []);
    } catch (error) {
        console.error("Error fetching branches:", error);
        return [];
    }
};

export const getBranchBySlug = async (slug) => {
    try {
        const res = await api.get(`/api/branches/slug/${slug}`);
        return res?.data;
    } catch (error) {
        console.error("Error fetching branch by slug:", error);
        return null;
    }
};



